import {useQuery} from "@tanstack/react-query";

import {householdService} from "../service";

export default function useHousehold(id: number | undefined | null) {
  const {data, isSuccess, isPending, isError} = useQuery({
    queryKey: ["households", {id}],
    queryFn: () => householdService.getHousehold(id!),
    enabled: Boolean(id),
    retry: false,
  });

  const household = id && isSuccess && data != null ? data : null;

  return {
    household,
    isPending: Boolean(id && isPending),
    isError,
  };
}
